import { createContext, useContext, type ReactNode, type ReactElement } from "react";
import type { ApiClient } from "../api/client.js";
import type { Catalog, Me, Branding } from "../types.js";

export interface PortalState {
  api: ApiClient;
  me: Me;
  catalog: Catalog;
  reloadCatalog: () => Promise<void>;
  productName: string;
  branding: Branding;
}

const PortalContext = createContext<PortalState | undefined>(undefined);

export function PortalProvider({ value, children }: { value: PortalState; children: ReactNode }): ReactElement {
  return <PortalContext.Provider value={value}>{children}</PortalContext.Provider>;
}

export function usePortal(): PortalState {
  const ctx = useContext(PortalContext);
  if (!ctx) throw new Error("usePortal must be used within PortalProvider");
  return ctx;
}

export function findService(catalog: Catalog, serviceId: string) {
  return catalog.find((s) => s.serviceId === serviceId);
}

export function findStage(catalog: Catalog, serviceId: string, stageId: string) {
  return findService(catalog, serviceId)?.stages.find((s) => s.id === stageId);
}
